import { EventTypeEnum, GroupTypeEnum } from 'graphql/types';

export const isEventType = (type: EventTypeEnum, isType: string) => {
  return type === isType || EventTypeEnum.Both === isType;
};

export const isGroupType = (type: GroupTypeEnum, isType: string) => {
  return type === isType || GroupTypeEnum.Both === isType;
};
